const Keys = ['min', 'max'];

const done = { done: true };

class Box3Iterator {
    constructor(box3, target = new THREE.Vector3()) {
        this._box3 = box3;
        this._target = target;

        this._i = 0;
        this._value = { value: target };
    }

    reset() {
        this._i = 0;
        return this;
    }

    next() {
        const i = this._i++;

        if (i === 8) {
            return done;
        }

        const box3 = this._box3, target = this._target;

        const keyX = Keys[Number(Boolean(i & 1))];
        const keyY = Keys[Number(Boolean(i & 2))];
        const keyZ = Keys[Number(Boolean(i & 4))];

        target.set(box3[keyX].x, box3[keyY].y, box3[keyZ].z);

        return this._value;
    }

    [Symbol.iterator]() {
        return this;
    }
}

export default Box3Iterator;
